module.exports = __webpack_public_path__ + "img/card-bg-vic-black.895b443f.png";